import { useEffect, useState } from 'react';
import { CURRENCIES } from 'types/bussines';
import { LOCAL_PRICE_INPUT_MODE } from 'types/global';
import { NudosMaskedNumberInput } from 'components/NudosComponents';
import BordSelectDropdown from 'components/NudosComponents/BordSelectDropdown/BordSelectDropdown';
import { PRICE_TYPE } from 'utils/logisticServiceEdition';

interface IServicePrice {
  priceUsd: string;
  totalValueLocal?: string;
  exchangeRate?: number;
}

interface IBulkPriceEditionRowProps {
  currency: string;
  exchangeRate?: number;
  totalItems: number;
  service?: ILogisticServiceTypeProps;
  price?: IServicePrice;
  onPriceChange: (serviceTypeId: number, price: IServicePrice, type: PRICE_TYPE) => void;
}

interface ILogisticServiceTypeProps {
  id: number;
  name: string;
  count: number;
  type: PRICE_TYPE;
}

const BulkPriceEditionRow = ({
  currency,
  exchangeRate,
  totalItems,
  service,
  price,
  onPriceChange
}: IBulkPriceEditionRowProps) => {
  const [localPriceInputMode, setLocalPriceInputMode] = useState<LOCAL_PRICE_INPUT_MODE>(LOCAL_PRICE_INPUT_MODE.HIDDEN);

  const currentPriceUsd = price?.priceUsd || '';
  const currentLocalPrice = price?.totalValueLocal || '';
  const showLocalPriceInput =
    localPriceInputMode === LOCAL_PRICE_INPUT_MODE.EDITABLE || localPriceInputMode === LOCAL_PRICE_INPUT_MODE.READONLY;

  const getLocalPriceInputMode = () => {
    switch (currency) {
      case CURRENCIES.USD:
        setLocalPriceInputMode(LOCAL_PRICE_INPUT_MODE.HIDDEN);
        break;
      case CURRENCIES.ARS:
      case CURRENCIES.BRL:
        setLocalPriceInputMode(LOCAL_PRICE_INPUT_MODE.EDITABLE);
        break;
      default:
        setLocalPriceInputMode(LOCAL_PRICE_INPUT_MODE.READONLY);
    }
  };

  const handlePriceUsdChange = (text: string = '') => {
    if (!service) return;

    const newPriceUsd = text || '';
    const numericPriceUsd = Number(newPriceUsd.replace(/[^0-9.]/g, '')) || 0;
    const exchangeRateValue = exchangeRate || price?.exchangeRate;
    const newTotalValueLocal =
      exchangeRateValue && !!numericPriceUsd ? String(numericPriceUsd * exchangeRateValue) : '';

    onPriceChange(
      service?.id,
      {
        priceUsd: newPriceUsd,
        totalValueLocal: newTotalValueLocal || price?.totalValueLocal,
        exchangeRate: exchangeRateValue
      },
      service?.type
    );
  };

  const handleLocalPriceChange = (text: string = '') => {
    if (!service) return;

    const newLocalPrice = text || '';
    const numericLocalPrice = Number(newLocalPrice?.replace(/[^0-9.]/g, '')) || 0;
    const numericPriceUsd = Number(currentPriceUsd?.replace(/[^0-9.]/g, '')) || 0;
    const baseExchangeRate = exchangeRate || price?.exchangeRate;

    const exchangeRateValue =
      !!numericPriceUsd && !!numericLocalPrice ? numericLocalPrice / numericPriceUsd : baseExchangeRate;

    onPriceChange(
      service?.id,
      {
        priceUsd: currentPriceUsd,
        totalValueLocal: newLocalPrice,
        exchangeRate: exchangeRateValue
      },
      service?.type
    );
  };

  useEffect(() => {
    getLocalPriceInputMode();
  }, [currency]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="editableServiceRow priceRow">
      {service && (
        <BordSelectDropdown
          selectOptions={[<span key={service?.id}>{service?.name}</span>]}
          currentValueOrplaceholder={service?.name}
          isFilled={true}
          label="Descripción o concepto"
          selectClassName="editPriceSelectDropdown"
        />
      )}
      <NudosMaskedNumberInput
        isFilled={true}
        label="Precio con IVA en USD"
        placeholder="Escribe el precio"
        handleChange={handlePriceUsdChange}
        numberOfDecimals={2}
        maskPrefix="$"
        maskSufix=" USD"
        currentValue={currentPriceUsd}
      />
      {showLocalPriceInput && (
        <NudosMaskedNumberInput
          isFilled={true}
          label={`Precio con IVA en ${currency}`}
          placeholder={`$0.00 ${currency}`}
          handleBlur={handleLocalPriceChange}
          numberOfDecimals={2}
          maskPrefix="$"
          maskSufix={` ${currency}`}
          currentValue={currentLocalPrice}
          customClassName="localPriceInput"
          isDeactivated={localPriceInputMode === LOCAL_PRICE_INPUT_MODE.READONLY}
        />
      )}
      <div className="countItemsContainer">
        <span className="countItems">
          {service?.count}/{totalItems}
        </span>
      </div>
    </section>
  );
};

export default BulkPriceEditionRow;
